import { render } from "./project-pipelines.vue?vue&type=template&id=ae4ee350"
import script from "./project-pipelines.vue?vue&type=script&lang=js"
export * from "./project-pipelines.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__